import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { Icon } from "../Common/Icon";
import Button from "../Common/Button";
import FlipPhone from "../../assets/icons/flip-device.png";

const LandscapeWarning = ({ onClose }) => {
  return (
    <div className="landscape-warning">
      <Icon onClick={onClose} className="landscape-warning__close" id="x" />
      <span className="landscape-warning__label">{i18n.t("landscapeWarning.label")}</span>
      <img src={FlipPhone} alt="flip phone" className="landscape-warning__icon" />
      <span className="landscape-warning__text">{i18n.t("landscapeWarning.text")}</span>
      <span className="landscape-warning__text">{i18n.t("landscapeWarning.closeAndContinue")}</span>
      <Button className="landscape-warning__button" label={i18n.t("landscapeWarning.close")} onClick={onClose} />
    </div>
  );
};

LandscapeWarning.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default LandscapeWarning;



// WEBPACK FOOTER //
// ./src/components/Errors/LandscapeWarning.js